export class TiltController {
  private gamma = 0;
  private enabled = false;
  private center = 0;

  private readonly listener = (event: DeviceOrientationEvent): void => {
    if (typeof event.gamma === "number") this.gamma = event.gamma;
  };

  async enable(center: number): Promise<"enabled" | "denied" | "unsupported"> {
    if (typeof globalThis.DeviceOrientationEvent !== "function")
      return "unsupported";
    const orientation =
      DeviceOrientationEvent as typeof DeviceOrientationEvent & {
        requestPermission?: () => Promise<"granted" | "denied">;
      };
    try {
      if (
        orientation.requestPermission &&
        (await orientation.requestPermission()) !== "granted"
      )
        return "denied";
      this.listen(center);
      return "enabled";
    } catch {
      return "denied";
    }
  }

  listen(center: number): void {
    this.center = center;
    this.enabled = true;
    globalThis.removeEventListener("deviceorientation", this.listener);
    globalThis.addEventListener("deviceorientation", this.listener);
  }

  disable(): void {
    this.enabled = false;
    globalThis.removeEventListener("deviceorientation", this.listener);
  }

  calibrate(): number {
    this.center = this.gamma;
    return this.center;
  }

  axis(sensitivity = 1): number {
    if (!this.enabled) return 0;
    const deadZone = 3;
    const delta = this.gamma - this.center;
    if (Math.abs(delta) <= deadZone) return 0;
    return Math.max(-1, Math.min(1, (delta / 22) * sensitivity));
  }
}
